import { Badge } from "@/components/ui/badge"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Typography } from "@/components/ui/typography"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useBillingStatus } from "@/services/api/billingService"
import { ManagePlanButton } from "./ManagePlanButton"

/** Settings card "Subscription": status and one button into the billing
 *  portal. Renders nothing unless the account has a Stripe customer the portal
 *  can open (it does not need the checkout). */
export const ManagePlanSection: React.FC = () => {
  const { translate } = useTranslation()
  const { data } = useBillingStatus()
  if (!data?.canManageBilling) return null
  return (
    <Card data-testid="subscription-card">
      <CardHeader>
        <CardTitle>{translate("UPGRADE/MANAGE_PLAN_TITLE")}</CardTitle>
        <Typography as="muted">
          {translate("UPGRADE/MANAGE_PLAN_DESCRIPTION")}
        </Typography>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {data.hasActiveSubscription && (
          <div className="flex items-center justify-between gap-4">
            <Typography as="muted">
              {translate("UPGRADE/STATUS_LABEL")}
            </Typography>
            <Badge variant="outline" className="gap-2">
              <span
                aria-hidden="true"
                className="size-2 rounded-full bg-success"
              />
              {translate("UPGRADE/STATUS_ACTIVE")}
            </Badge>
          </div>
        )}
        <div>
          <ManagePlanButton variant="outline" />
        </div>
      </CardContent>
    </Card>
  )
}
